import React from 'react';
import classnames from 'classnames';

export type CheckboxButtonProps = {
  className?: string;
  buttonName: string;
  checked: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};

const CheckboxButton = ({
  className = '',
  buttonName,
  checked,
  onClick,
  disabled = false,
}: CheckboxButtonProps) => (
  <button
    disabled={disabled}
    className={classnames('custom-checkbox-button', className, checked ? '--checked' : '')}
    onClick={onClick}
  >
    <div className="custom-checkbox-button__checkbox" />
    <div className="custom-checkbox-button__name">{buttonName}</div>
  </button>
);

export default CheckboxButton;
